var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userBox"},[_c('div',{staticClass:"text-left"},[_c('h1',[_vm._v("儿童隐私保护指引")]),_c('div',{staticClass:"text-left-text",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }